import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-update-device-configuration',
  standalone: true,
  imports: [],
  templateUrl: './confirm-update-device-configuration.component.html',
  styleUrl: './confirm-update-device-configuration.component.scss'
})
export class ConfirmUpdateDeviceConfigurationComponent {

  constructor(
  @Inject(MAT_DIALOG_DATA) public binData: any,
  private dialogRef: MatDialogRef<ConfirmUpdateDeviceConfigurationComponent>
) {
  console.log('Dialog Data:', this.binData);
}

onCancel() {
  this.dialogRef.close(false);
}

onConfirm() {
  this.dialogRef.close('publish'); // return "publish" to parent
}

}
